import Component from "./PageSettingsCurrencies.vue";
export default Component;
